import * as angular from 'angular';
import * as _ from 'underscore';
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { Brand } from '../core';


export interface IBrandAnchor {
    name: string;
    value: string;
    selected: boolean;
    disabled: boolean;
}

export interface IBrandAnchors {
    anchors: IBrandAnchor[];
    char: string;
    regWord: RegExp;
}

export interface IBrand extends Brand {
    Status?: number;
    last?: boolean;
    forApproval?: boolean;
    selected?: boolean;
    anchor?: string;
}

export interface IBrandStatuses {
    pending: number;
    rejected: number;
    approved: number;
}

export interface IBrandHtmlTooltip {
    awaitingApproval: string;
    rejected: string;
    unknown: string;
}

export class BrandsService {
    static $inject = ['$q', 'http', 'retailerService', 'enumService'];

    statuses: IBrandStatuses = {
        pending: this.enumService.ClassificationCategoryBrandStatus.Pending,
        rejected: this.enumService.ClassificationCategoryBrandStatus.Rejected,
        approved: this.enumService.ClassificationCategoryBrandStatus.Approved
    };

    private regWord = new RegExp('^[a-z]', 'i');
    private anchors: IBrandAnchor[] = [];
    private anchorChar = 'char';
    private levelDefault = 3;
    private approvedBrands: IBrand[] = null;

    constructor(
        private $q: ng.IQService,
        private http: HttpService,
        private retailerService: RetailerService,
        private enumService: EnumService
    ) {
        _.forEach('abcdefghijklmnopqrstuvwxyz#'.toUpperCase().split(''), (name, index) => {
            this.anchors.push({
                name: name,
                value: name === '#' ? this.anchorChar : name,
                selected: false,
                disabled: false
            });
        });
    }


    getBrandAnchors = (): IBrandAnchors => {
        return {
            anchors: this.anchors,
            char: this.anchorChar,
            regWord: this.regWord
        };
    }

    getByClassificationCategoryID = async (id: number[]) => {

        try {
            let brands = await this.http.get<IBrand[]>(this.retailerService.brandsClassification(), { params: { cID: id } });
            brands.map(this.toApproved);
            return this.$q.when(brands);
        } catch (error) {
            return this.$q.reject(error);
        }
    }

    getCategoryBrands = (id) => {
        return this.http.get<[number, Brand[]]>(this.retailerService.dictionaryBrands(), { params: { cID: id } });
    }

    getApprovedBrands = async () => {

        try {
            if (this.approvedBrands == null) {
                this.approvedBrands = await this.http.get<IBrand[]>(this.retailerService.approvedBrands());
            }
            return this.$q.when(this.approvedBrands);
        } catch (error) {
            return this.$q.reject(error);
        }
    }

    brandsSiblingCategories = async (id: number, level?: number) => {
        try {
            let brands = await this.http.get<IBrand[]>(this.retailerService.brandsSiblingCategories(id, level ? level : this.levelDefault));
            brands.map(this.toPending);
            return this.$q.when(brands);
        } catch (error) {
            return this.$q.reject(error);
        }
    }

    private toApproved = (brand) => {
        brand.Status = this.statuses.approved;
    }

    private toPending = (brand) => {
        brand.Status = this.statuses.pending;
    }
}

angular
    .module('naut')
    .service('brandsService', BrandsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/brands/brands.service.ts